import routes, { ESTATE_KEY, buildRoute } from './routes'

export const Routes = { ...routes, ESTATE_KEY, buildRoute }

export { default as ACL } from './ACL'
export { default as APIHeaders } from './APIHeaders'
export { default as colors } from './colors'
export { default as ContentTypes } from './ContentTypes'
export { default as Dashboards } from './Dashboards'
export { default as estate } from './estate'
export { default as Layers } from './Layers'
export { default as Media } from './Media'
export { default as Roles } from './Roles'
/**
 * @deprecated Use `Routes`
 */
export { default as routes } from './routes'
export { default as sections } from './sections'
export { default as Sizes } from './Sizes'
export { default as Tables } from './Tables'
